export default __webpack_public_path__ + "locales/ko-KR/HotkeysPanel.json?hash=d9148a3940aa91beeea6d451673006d9";